export class TooltipProvider {
    constructor() {
        this.config = {
            animation: true,
            delay: 0,
            placement: 'bottom',
            html: false,
            title: '',
            trigger: 'hover focus'
        };
    }
    $get() {
        return this.config;
    }
}
